import classified from "@/http/requests/classified"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      classified.fetch(queryData).then(response => {
        commit('SET_CLASSIFIEDS', response.data.data.classifieds)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      classified.add(data).then(response => {
        commit('ADD_CLASSIFIED', response.data.data.createClassified)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, classifiedId) {
    return new Promise((resolve, reject) => {
      classified.delete(classifiedId).then(response => {
        commit('DELETE_CLASSIFIED', classifiedId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, classifiedId) {
    return new Promise((resolve, reject) => {
      classified.infos(classifiedId).then(response => {
        commit('SET_CLASSIFIED_INFOS', response.data.data.classifiedInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
